import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  Table,
  Input,
  Typography,
  Select,
  Switch,
  Checkbox,
  Tooltip,
  Layout,
  message,
  Modal,
  Popconfirm,
  Breadcrumb,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  getWorkspaceAutoChannelSync,
  searchJiraProjects,
  dropDownSearchJiraProjects,
  getProject,
  getProjectIssueFields,
  getIssues,
  verifyJql,
  createAutoChannelSync,
  upadteAutoChannelSync,
  deleteAutoChannelSync,
} from '../skills_action';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import GetIssueField from './getIssueField';
import queryString from 'query-string';

const { Option } = Select;
const { Text } = Typography;
const { Search } = Input;
const { Content } = Layout;

const ChannelSync = (props) => {
  const {
    // getProject,
    // issues,
    // isAdmin,
    // getIssues,
    // skills,
    // members,
    // team,
    // user_now,
    skill,
    // dropDownSearchJiraProjects,
    match: {
      params: { wId, sub_skill, skill_id },
    },
  } = props;
  const dispatch = useDispatch();
  const jiraSkill =
    skill && skill.skill_metadata ? skill.skill_metadata : skill;
  const defaultAutoChannelSyncdata = {
    workspace_id: wId,
    skill_id: skill_id,
    sub_skill,
    disabled: true,
    make_private_channel: true,
    new_channelsync_channel_name: '@@@jira_issue_key@@@-troopr-sync',
  };
  let parsed_query = queryString.parse(props.location.search);

  const projects = useSelector((store) => store.skills.projects);
  const user_now = useSelector((store) => store.common_reducer.user);
  const isWorkspaceAdmin = useSelector((store) => store.common_reducer.isAdmin);
  const isJiraAdmin = jiraSkill.jiraConnectedId === user_now._id;
  const accessToEdit = isWorkspaceAdmin || isJiraAdmin;

  const [autoChannelSync, set_autoChannelSync] = useState(
    defaultAutoChannelSyncdata
  );
  const [autoChannelSyncs, set_autoChannelSyncs] = useState([]);
  const [autoChannelSyncsLoading, set_autoChannelSyncsLoading] =
    useState(false);
  const [apiLoading, set_apiLoading] = useState(false);
  const [fields, set_fields] = useState([]);
  const [errorValidation, set_errorValidation] = useState({});
  const [isEdit, set_isEdit] = useState(false);

  const type_of_task = sub_skill === 'jira_service_desk' ? 'request' : 'issue';
  const type_of_task_upper_case =
    sub_skill === 'jira_service_desk' ? 'Request' : 'Issue';

  useEffect(() => {
    if (parsed_query && parsed_query.acs_edit) {
      set_isEdit(true);
    }
    set_autoChannelSyncsLoading(true);
    getWorkspaceAutoChannelSync(wId, sub_skill).then((res) => {
      if (res && res.data && res.data.success) {
        if (res.data.autoChannelSyncs) {
          set_autoChannelSyncs(res.data.autoChannelSyncs);
          //   set_originalAutoChannelSync(res.data.autoChannelSync);
          set_autoChannelSyncsLoading(false);

          if (parsed_query && parsed_query.acs_edit) {
            if (parsed_query.acs_edit === 'new')
              set_autoChannelSync(defaultAutoChannelSyncdata);
            else {
              const currentAutoChannelSync = res.data.autoChannelSyncs.find(
                (acs) => acs._id === parsed_query.acs_edit
              );
              if (currentAutoChannelSync)
                set_autoChannelSync(currentAutoChannelSync);
              else {
                set_isEdit(false);
                props.history.push(
                  `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync`
                );
              }
            }
          }
          getRequiredData(res.data.autoChannelSyncs);
        }
      }
    });
  }, []);

  const getRequiredData = (allAutoChannelSyncs) => {
    if (jiraSkill && jiraSkill.metadata && jiraSkill.metadata.server_type) {
      const server_type = jiraSkill.metadata.server_type;

      if (
        server_type === 'jira_server_oauth' ||
        server_type === 'jira_server'
      ) {
        dispatch(getProject(wId));
      } else {
        const query =
          sub_skill === 'jira_service_desk'
            ? '?query=typeKey=service_desk'
            : '?query=typeKey=software,business';
        dispatch(searchJiraProjects(wId, query)).then((res) => {
          if (res.data.success) {
            if (
              parsed_query &&
              parsed_query.acs_edit &&
              parsed_query.acs_edit !== 'new'
            ) {
              const autoChannelSync = allAutoChannelSyncs.find(
                (acs) => acs._id === parsed_query.acs_edit
              );
              getMissingProject(autoChannelSync);
              getProjectFields(autoChannelSync.start_channelsync_project);
            }

            // if (
            //   autoChannelSyncData &&
            //   !res.data.projectsData.values.find(
            //     (p) => p.id === autoChannelSyncData.start_channelsync_project.id
            //   )
            // ) {
            //   let query = `query=${autoChannelSyncData.start_channelsync_project.key}`;
            //   dispatch(dropDownSearchJiraProjects(wId, `?query=${query}`));
            // }
          }
        });
      }

      // if (autoChannelSyncData)
      //   getProjectFields(autoChannelSyncData.start_channelsync_project);

      // .then((res) => {
      // if (res.data.success) {
      // const channelFound = commonChanneldata.find((cha) => cha.channel_id === channel_id);
      // if(channelFound && channelFound.channel_linking_id && channelFound.channel_linking_id.link_info &&channelFound.channel_linking_id.link_info.project){
      //   const query = `id=${channelFound.channel_linking_id.link_info.project.id}`;
      //   if(!this.props.projects.find(pro => pro.id === channelFound.channel_linking_id.link_info.project.id)) {
      //     this.props.dropDownSearchJiraProjects(wId, `?query=${query}`)
      //   }
      // }
      // this.getMissingProjects() /* to get missing proects in project restriction list */
      // }
      // });
    }
  };

  const getMissingProject = (autoChannelSync) => {
    if (
      autoChannelSync &&
      !projects.find(
        (p) => p.id === autoChannelSync.start_channelsync_project.id
      )
    ) {
      let query = `query=${autoChannelSync.start_channelsync_project.key}`;
      dispatch(dropDownSearchJiraProjects(wId, `?query=${query}`));
    }
  };

  const getFieldsWithKey = (fields) => {
    let tempArr = Object.entries(fields);
    let fieldsWithKey = tempArr.map((field) => {
      let field_obj = { ...field[1] };
      field_obj.key = field[0];
      return field_obj;
    });
    return fieldsWithKey;
  };

  const getProjectFields = (project) => {
    dispatch(
      getIssues(wId, project.id, false, false, false, user_now._id)
    ).then(async (res) => {
      if (res && res.data && res.data.success) {
        const issueTypes = res.data.issueTypes;
        let issueFieldsPromiseArr = [];
        issueTypes.forEach((issue) =>
          issueFieldsPromiseArr.push(
            getProjectIssueFields(
              wId,
              skill_id,
              project.id,
              user_now._id,
              issue.id
            )
          )
        );
        const allIssueTypesData = await Promise.all(issueFieldsPromiseArr);

        let allFieldsOfProject = {};
        allIssueTypesData.forEach((issueTypeData) => {
          const issueTypeFields =
            issueTypeData.data.items.projects[0].issuetypes[0].fields;
          allFieldsOfProject = { ...allFieldsOfProject, ...issueTypeFields };
        });
        let fields = [];

        for (const field of getFieldsWithKey(allFieldsOfProject)) {
          if (!field.key) {
            field.key = field.fieldId;
          }
          if (
            field.key !== 'issuetype' &&
            field.key !== 'attachment' &&
            field.key !== 'project' &&
            field.key !== 'summary' &&
            !(
              field.schema &&
              (field.schema.custom ==
                'com.pyxis.greenhopper.jira:gh-lexo-rank' ||
                field.schema.custom ==
                  'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf')
            ) &&
            (field.schema.items !== 'issuelinks' ||
              (field.schema.custom &&
                field.schema.custom !== 'com.pyxis.greenhopper.jira:gh-sprint'))
          ) {
            if (!fields.find((f) => f.key === field.key)) fields.push(field);
          }
        }
        set_fields(fields);
      }
    });
  };

  let timeout = 0;
  const onProjectSearch = (val) => {
    if (
      jiraSkill &&
      jiraSkill.metadata &&
      (jiraSkill.metadata.server_type === 'jira_cloud_oauth' ||
        jiraSkill.metadata.server_type === 'jira_cloud')
    ) {
      const project_type_query =
        sub_skill === 'jira_service_desk'
          ? '&typeKey=service_desk'
          : '&typeKey=software,business';
      let query = `query=${val || ''}`;
      query += project_type_query;

      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        dispatch(dropDownSearchJiraProjects(wId, `?query=${query}`));
      }, 300);
    }
  };

  const handleChange = (type, value, data) => {
    let temp_autoChannelSync = { ...autoChannelSync };
    let temp_errorValidation = { ...errorValidation };

    if (type === 'start_channelsync_project') {
      temp_autoChannelSync[type] = data.project;
      getProjectFields(data.project);
      delete temp_autoChannelSync.start_channelsync_event;
      delete temp_autoChannelSync.start_channelsync_field;
      delete temp_autoChannelSync.start_channelsync_field_target;
      delete temp_errorValidation.start_channelsync_project;
      delete temp_errorValidation.start_channelsync_project_already_configured;
    } else if (type === 'start_channelsync_jql') {
      temp_autoChannelSync[type] = value.target.value;
      delete temp_errorValidation.start_channelsync_jql;
    } else if (type === 'new_channelsync_channel_name') {
      // temp_autoChannelSync[type] = value.target.value
      //   ? value.target.value.replaceAll(' ', '-').toLowerCase()
      //   : '';
      temp_autoChannelSync[type] = value.target.value || '';
      delete temp_errorValidation.new_channelsync_channel_name;
    } else if (type === 'start_channelsync_event') {
      temp_autoChannelSync[type] = value;
      if (value === 'jira:issue_created') {
        delete temp_autoChannelSync.start_channelsync_field;
        delete temp_autoChannelSync.start_channelsync_field_target;
      }
      delete temp_errorValidation.start_channelsync_event;
    } else if (type === 'start_channelsync_field') {
      temp_autoChannelSync[type] = data.field;
      delete temp_autoChannelSync.start_channelsync_field_target;
      delete temp_errorValidation.start_channelsync_field;
    } else if (type === 'start_channelsync_field_target') {
      if (
        autoChannelSync.start_channelsync_field.schema.type === 'user' ||
        autoChannelSync.start_channelsync_field.schema.items === 'user'
      ) {
        temp_autoChannelSync[type] = value.optionData;
      } else temp_autoChannelSync[type] = value.value;
      delete temp_errorValidation.start_channelsync_field_target;
    } else if (type === 'make_private_channel') {
      temp_autoChannelSync[type] = value.target.checked;
    } else if (type === 'add_users_from_field') {
      temp_autoChannelSync[type] = data.field;
    }
    set_autoChannelSync(temp_autoChannelSync);
    set_errorValidation(temp_errorValidation);
  };

  const onSave = () => {
    let errorValidation = {};

    if (!autoChannelSync.start_channelsync_project)
      errorValidation.start_channelsync_project = true;
    if (
      autoChannelSync &&
      !autoChannelSync._id &&
      autoChannelSync.start_channelsync_project
    ) {
      if (
        autoChannelSyncs.find(
          (acs) =>
            acs.start_channelsync_project.id ===
            autoChannelSync.start_channelsync_project.id
        )
      )
        errorValidation.start_channelsync_project_already_configured = true;
    }
    if (!autoChannelSync.start_channelsync_jql)
      errorValidation.start_channelsync_jql = true;
    if (!autoChannelSync.start_channelsync_event)
      errorValidation.start_channelsync_event = true;
    if (!autoChannelSync.new_channelsync_channel_name)
      errorValidation.new_channelsync_channel_name = true;
    if (
      autoChannelSync.start_channelsync_event &&
      autoChannelSync.start_channelsync_event === 'jira:issue_updated' &&
      !autoChannelSync.start_channelsync_field
    )
      errorValidation.start_channelsync_field = true;
    if (
      autoChannelSync.start_channelsync_event &&
      autoChannelSync.start_channelsync_field &&
      !autoChannelSync.start_channelsync_field_target
    )
      errorValidation.start_channelsync_field_target = true;
    set_errorValidation(errorValidation);
    if (Object.keys(errorValidation).length === 0) {
      set_apiLoading(true);
      verifyJql(wId, autoChannelSync.start_channelsync_jql).then((res) => {
        if (res && res.data && res.data.success) {
          if (autoChannelSync._id) {
            upadteAutoChannelSync(
              wId,
              autoChannelSync._id,
              autoChannelSync
            ).then((res) => {
              if (res.data.success && res.data.autoChannelSync) {
                set_isEdit(false);
                set_apiLoading(false);
                message.success(
                  'Automatic Channel Sync configuration updated successfully!'
                );
                set_autoChannelSyncs(
                  autoChannelSyncs.map((acs) =>
                    acs._id === res.data.autoChannelSync._id
                      ? res.data.autoChannelSync
                      : acs
                  )
                );
                props.history.push(
                  `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync`
                );
                // set_autoChannelSync(res.data.autoChannelSync);
                // set_originalAutoChannelSync(res.data.autoChannelSync);
              }
            });
          } else {
            autoChannelSync.disabled = false;
            createAutoChannelSync(wId, autoChannelSync).then((res) => {
              if (res.data.success && res.data.autoChannelSync) {
                set_isEdit(false);
                set_apiLoading(false);
                message.success(
                  'Automatic Channel Sync configuration created successfully!'
                );
                set_autoChannelSyncs([
                  ...autoChannelSyncs,
                  res.data.autoChannelSync,
                ]);
                props.history.push(
                  `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync`
                );
                // set_autoChannelSync(res.data.autoChannelSync);
                // set_originalAutoChannelSync(res.data.autoChannelSync);
              }
            });
          }
        } else if (res.data.error) {
          message.error(res.data.error.message);
        }
      });
    }
  };

  const handleSwitch = (checked, autoChannelSync_id) => {
    upadteAutoChannelSync(wId, autoChannelSync_id, {
      disabled: !checked,
    }).then((res) => {
      if (res.data.success && res.data.autoChannelSync) {
        set_autoChannelSyncs(
          autoChannelSyncs.map((acs) =>
            res.data.autoChannelSync._id === acs._id
              ? res.data.autoChannelSync
              : acs
          )
        );
        // set_autoChannelSync(res.data.autoChannelSync);
        // set_originalAutoChannelSync(res.data.autoChannelSync);
      }
    });
  };

  const handleCancel = () => {
    set_isEdit(false);
    set_errorValidation({});
    props.history.push(
      `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync`
    );
    // if (autoChannelSync && autoChannelSync._id) {
    //   getProjectFields(autoChannelSync.start_channelsync_project);
    //   set_autoChannelSync(originalAutoChannelSync);
    // } else {
    //   set_autoChannelSync(defaultAutoChannelSyncdata);
    // }
  };

  const handleAutoChannelsyncEditClick = (autoChannelSync) => {
    set_isEdit(true);
    set_autoChannelSync(autoChannelSync);
    getMissingProject(autoChannelSync);
    getProjectFields(autoChannelSync.start_channelsync_project);
    props.history.push(
      `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync&acs_edit=${autoChannelSync._id}`
    );
  };

  const handleCreateNewAutoChannelSync = () => {
    set_isEdit(true);
    set_autoChannelSync(defaultAutoChannelSyncdata);
    props.history.push(
      `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync&acs_edit=new`
    );
  };

  const handleAutoChannelSyncDelete = (autoChannelSync) => {
    deleteAutoChannelSync(wId, autoChannelSync._id).then((res) => {
      if (res && res.data && res.data.success) {
        let temp = [];
        autoChannelSyncs.forEach((acs) => {
          if (acs._id !== res.data.deletedAutoChannelSync._id) temp.push(acs);
        });
        set_autoChannelSyncs(temp);
        message.success(
          'Automatic Channel Sync configuration deleted successfully!'
        );
      }
    });
  };

  const columns = [
    {
      title: 'Project',
      key: 'project',
      ellipsis: {
        showTitle: false,
      },
      render: (value, autoChannelSync) => {
        return (
          <a
            type='link'
            onClick={() => {
              if (accessToEdit) handleAutoChannelsyncEditClick(autoChannelSync);
            }}
          >
            {`${autoChannelSync.start_channelsync_project.name} (${autoChannelSync.start_channelsync_project.key})`}
          </a>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      // align : 'right',
      width: 300,
      render: (value, autoChannelSync) => {
        return (
          <>
            <Button
              style={{ marginRight: 16 }}
              onClick={() => handleAutoChannelsyncEditClick(autoChannelSync)}
              disabled={accessToEdit ? false : true}
            >
              Update
            </Button>
            <Switch
              onChange={(checked) => handleSwitch(checked, autoChannelSync._id)}
              //   disabled={accessToEdit ? isEdit : true}
              checked={!autoChannelSync.disabled}
              disabled={accessToEdit ? false : true}
            />
            <Popconfirm
              disabled={accessToEdit ? false : true}
              title='Are you sure want to delete this automatic channel sync configuration?'
              okText='Delete'
              onConfirm={() => handleAutoChannelSyncDelete(autoChannelSync)}
              placement='leftTop'
            >
              <Button type='link' disabled={accessToEdit ? false : true}>
                <Text type='danger'>Delete</Text>
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <>
      {isEdit && (
        <Breadcrumb style={{ marginTop: '20px', marginBottom: '20px' }}>
          <Breadcrumb.Item
            onClick={() =>
              props.history.push(
                `/${wId}/skills/${props.match.params.skill_id}/${sub_skill}?view=channel_sync`
              )
            }
          >
            <Button
              type='link'
              style={{ padding: 0 }}
              onClick={() => handleCancel()}
            >
              Channel Syncs
            </Button>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {parsed_query && parsed_query.acs_edit === 'new'
              ? 'Create Automatic Channel Sync'
              : 'Update Automatic Channel Sync'}
          </Breadcrumb.Item>
        </Breadcrumb>
      )}
      <Card
        loading={autoChannelSyncsLoading}
        title={
          isEdit ? (
            parsed_query && parsed_query.acs_edit === 'new' ? (
              'Create Automatic Channel Sync'
            ) : (
              'Update Automatic Channel Sync'
            )
          ) : (
            <>
              <span>Automatic Channel Sync</span>
              <Tooltip title='Automatically create Slack channels with Channel sync when these Jira issues are created or updated (max 15 per minute)'>
                <InfoCircleOutlined style={{ marginLeft: 8 }} />
              </Tooltip>
            </>
          )
        }
        // extra={
        //   autoChannelSync._id && (
        //     <Switch
        //       disabled={accessToEdit ? isEdit : true}
        //       checked={!autoChannelSync.disabled}
        //       onChange={(checked) => handleSwitch(checked)}
        //     />
        //   )
        // }
        extra={
          isEdit
            ? ''
            : accessToEdit && (
                <div>
                  <Button
                    // type='primary'
                    onClick={() => handleCreateNewAutoChannelSync()}
                    style={{ float: 'right', marginTop: 16 }}
                    //   disabled = {accessToEdit ? false : true}
                  >
                    + New Automatic Channel Sync
                  </Button>
                </div>
              )
        }
      >
        {isEdit ? (
          <>
            <Card style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 16 }}>
                <Text>Start channel sync only for these issues in Jira</Text>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                <div>
                  <Select
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder='Choose Project'
                    style={{ width: 300 }}
                    loading={projects.length === 0}
                    showSearch
                    onSearch={onProjectSearch}
                    onChange={(value, data) =>
                      handleChange('start_channelsync_project', value, data)
                    }
                    value={
                      autoChannelSync.start_channelsync_project &&
                      autoChannelSync.start_channelsync_project.id
                    }
                    disabled={accessToEdit ? !isEdit : true}
                  >
                    {projects &&
                      [
                        ...(sub_skill === 'jira_service_desk'
                          ? projects.filter(
                              (project) =>
                                project.projectTypeKey === 'service_desk'
                            )
                          : projects.filter(
                              (project) =>
                                project.projectTypeKey === 'software' ||
                                project.projectTypeKey === 'business'
                            )),
                      ].map((project) => {
                        return (
                          <Option
                            key={project.id}
                            value={project.id}
                            project={project}
                          >{`${project.name} (${project.key})`}</Option>
                        );
                      })}
                  </Select>
                  {errorValidation.start_channelsync_project && (
                    <>
                      <br /> <Text type='danger'>* Please choose project</Text>
                    </>
                  )}
                  {errorValidation.start_channelsync_project_already_configured && (
                    <>
                      <br />{' '}
                      <Text type='danger'>
                        * Selected project already configured
                      </Text>
                    </>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    placeholder='Type JQL here'
                    onChange={(event) =>
                      handleChange('start_channelsync_jql', event)
                    }
                    value={autoChannelSync.start_channelsync_jql || null}
                    disabled={accessToEdit ? !isEdit : true}
                  />
                  {errorValidation.start_channelsync_jql && (
                    <>
                      <br /> <Text type='danger'>* Please type JQL</Text>
                    </>
                  )}
                </div>
              </div>
            </Card>
            <Card style={{ marginBottom: 16 }}>
              <div
                style={{
                  // marginBottom: 16,
                  display: 'flex',
                  flexDirection: 'column',
                  // backgroundColor: '#efefef',
                  // padding: 16,
                }}
              >
                <div
                  style={{
                    marginBottom: 16,
                  }}
                >
                  <Text>Start channel sync only when this happens in Jira</Text>
                </div>
                <div
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <Select
                    placeholder='Click to choose'
                    style={{ width: 300 }}
                    onChange={(value, data) =>
                      handleChange('start_channelsync_event', value, data)
                    }
                    disabled={
                      accessToEdit
                        ? isEdit
                          ? autoChannelSync &&
                            autoChannelSync.start_channelsync_project &&
                            autoChannelSync.start_channelsync_project.id
                            ? false
                            : true
                          : true
                        : true
                    }
                    value={autoChannelSync.start_channelsync_event}
                  >
                    <Option value='jira:issue_created' key='jira:issue_created'>
                      Issue is created
                    </Option>
                    <Option value='jira:issue_updated' key='jira:issue_updated'>
                      Issue field is updated
                    </Option>
                  </Select>
                  {errorValidation.start_channelsync_event && (
                    <>
                      <br />{' '}
                      <Text type='danger'>* Please choose an option</Text>
                    </>
                  )}
                </div>
                {autoChannelSync &&
                  autoChannelSync.start_channelsync_event &&
                  autoChannelSync.start_channelsync_event ===
                    'jira:issue_updated' && (
                    <div
                      style={{ display: 'flex', flexDirection: 'row', gap: 8 }}
                    >
                      <div>
                        <div style={{ marginBottom: 5 }}>
                          <Text>choose field</Text>
                        </div>
                        <div>
                          <Select
                            placeholder='Click to choose'
                            onChange={(value, data) =>
                              handleChange(
                                'start_channelsync_field',
                                value,
                                data
                              )
                            }
                            loading={fields.length > 0 ? false : true}
                            style={{ width: 300 }}
                            value={
                              autoChannelSync.start_channelsync_field &&
                              autoChannelSync.start_channelsync_field.key
                            }
                            disabled={accessToEdit ? !isEdit : true}
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            showSearch
                          >
                            {fields.map((field) => {
                              return (
                                <Option
                                  field={field}
                                  key={field.key}
                                  value={field.key}
                                >
                                  {field.name}
                                </Option>
                              );
                            })}
                          </Select>
                          {errorValidation.start_channelsync_field && (
                            <>
                              <br />{' '}
                              <Text type='danger'>* Please choose field</Text>
                            </>
                          )}
                        </div>
                      </div>
                      {autoChannelSync &&
                        autoChannelSync.start_channelsync_field && (
                          <div style={{ flex: 1 }}>
                            <div style={{ marginBottom: 5 }}>
                              <Text>choose field value</Text>
                            </div>
                            <div>
                              <div style={{ marginBottom: '-15px' }}>
                                <GetIssueField
                                  field={
                                    autoChannelSync.start_channelsync_field
                                  }
                                  linkedProject={
                                    autoChannelSync.start_channelsync_project.id
                                  }
                                  onFieldChange={(value) =>
                                    handleChange(
                                      'start_channelsync_field_target',
                                      value
                                    )
                                  }
                                  initialValue={
                                    autoChannelSync.start_channelsync_field_target
                                  }
                                  skill_id={skill_id}
                                  forChannelSync={true}
                                  key={
                                    autoChannelSync.start_channelsync_field.key
                                  }
                                  disableEdit={accessToEdit ? !isEdit : true}
                                />
                              </div>
                              {errorValidation.start_channelsync_field_target && (
                                <>
                                  <Text type='danger'>
                                    * Please choose field target
                                  </Text>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  )}
              </div>
            </Card>
            <Card>
              <div style={{ marginBottom: 8 }}>
                <Text style={{ marginRight: 8 }}>
                  New Slack channel configuration
                </Text>{' '}
                <a
                  onClick={() =>
                    Modal.info({
                      title: 'Channel name syntax',
                      content: (
                        <div>
                          <div>
                            <Text>
                              Channel names may only contain lowercase letters,
                              numbers, hyphens, and underscores. Max length of
                              the channel name is 80 characters. Longer names
                              will be automatically truncated.
                            </Text>
                          </div>
                          <div style={{ marginTop: 16 }}>Dynamic values:</div>
                          <div>
                            Use <Text strong>{'@@@jira_issue_key@@@'}</Text> for
                            issue key
                          </div>
                          <div>
                            Use <Text strong>{'@@@jira_issue_summary@@@'}</Text>{' '}
                            for issue summary
                          </div>
                          <div>
                            Use{' '}
                            <Text strong>{`@@@jira_issue_(fieldname)@@@`}</Text>{' '}
                            for issue field value (only single line text type)
                          </div>
                          <div style={{ marginTop: 16 }}>Example: </div>
                          <div>
                            For issue key "TP-100" and summary "nginx server is
                            down in AWS us-west-2 data center at 5:15 pm EST on
                            aug 15 2022" and "Affected hardware" field value is
                            "laptop" then the following channel names can be
                            created
                            <Table
                              pagination={false}
                              dataSource={[
                                {
                                  key: '1',
                                  syntax: '@@@jira_issue_key@@@-troopr-sync',
                                  name: 'TP-100-troopr-sync',
                                },
                                {
                                  key: '2',
                                  syntax:
                                    'troopr-sync-@@@jira_issue_summary@@@',
                                  name: 'troopr-sync-nginx-server-is-down-in-aws-us-west-2-data-center-at-5-15-pm-est-on',
                                },
                                {
                                  key: '2',
                                  syntax:
                                    'troopr-sync-@@@jira_issue_Affected hardware@@@',
                                  name: 'troopr-sync-laptop',
                                },
                              ]}
                              columns={[
                                {
                                  title: 'Syntax',
                                  dataIndex: 'syntax',
                                  key: 'syntax',
                                },
                                {
                                  title: 'Name',
                                  dataIndex: 'name',
                                  key: 'name',
                                },
                              ]}
                            />
                            {/* <Text strong>@@@jira_issue_key@@@-troopr-sync</Text> will create a
                              channel <Text strong>TP-100-troopr-sync</Text> */}
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <Text type='warning'>
                              When the provided channel name could not be
                              created, following fallback syntax will be used:{' '}
                            </Text>
                            <Text type='warning'>
                              {
                                'troopr-sync-@@@datetime@@@ (example: troopr-sync-2022-03-25t12-00-00-06-30)'
                              }
                            </Text>
                          </div>
                        </div>
                      ),
                      onOk() {},
                      width: 800,
                    })
                  }
                >
                  Show channel name syntax
                </a>
              </div>
              <div style={{ marginBottom: 8 }}>
                <Input
                  value={autoChannelSync.new_channelsync_channel_name || null}
                  placeholder='troopr-sync'
                  onChange={(e) =>
                    handleChange('new_channelsync_channel_name', e)
                  }
                  maxLength={80}
                  disabled={accessToEdit ? !isEdit : true}
                />
                {errorValidation.new_channelsync_channel_name && (
                  <>
                    <br />{' '}
                    <Text type='danger'>
                      * Please type slack channel configuration
                    </Text>
                  </>
                )}
              </div>
              <div style={{ marginBottom: 8 }}>
                <Checkbox
                  disabled={accessToEdit ? !isEdit : true}
                  checked={autoChannelSync.make_private_channel}
                  onChange={(checked) =>
                    handleChange('make_private_channel', checked)
                  }
                >
                  Make channel private
                </Checkbox>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                <div>
                  <div style={{ marginBottom: 5 }}>
                    <Text>
                      Add people from a field to the channel (optional)
                    </Text>
                    <Tooltip title='When a user field is configured, Troopr will attempt to add the user(s) selected in the field to the channel. Users from following user fields will be added automatically (can be disabled in "New Channel Sync Defaults" configuration): Assignee, Reporter, Request Participants.'>
                      <InfoCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </div>
                  <div>
                    <Select
                      placeholder='Click to choose'
                      onChange={(value, data) =>
                        handleChange('add_users_from_field', value, data)
                      }
                      loading={fields.length > 0 ? false : true}
                      style={{ width: 300 }}
                      value={
                        autoChannelSync.add_users_from_field &&
                        autoChannelSync.add_users_from_field.key
                      }
                      disabled={accessToEdit ? !isEdit : true}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {fields
                        .filter(
                          (field) =>
                            field.key !== 'assignee' &&
                            field.key !== 'reporter' &&
                            field.name !== 'Request participants'
                        )
                        .filter(
                          (field) =>
                            field.schema.type === 'user' ||
                            field.schema.items === 'user'
                        )
                        .map((field) => {
                          return (
                            <Option
                              field={field}
                              key={field.key}
                              value={field.key}
                            >
                              {field.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                </div>
              </div>
            </Card>
            {/* {accessToEdit && ( */}
            <div>
              {/* {isEdit ? ( */}
              {accessToEdit && (
                <>
                  <Button
                    type='primary'
                    onClick={() => onSave()}
                    loading={apiLoading}
                    style={{ float: 'right', marginTop: 16, marginLeft: 16 }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={() => handleCancel()}
                    style={{ float: 'right', marginTop: 16 }}
                  >
                    Cancel
                  </Button>
                </>
              )}
              {/* ) : ( */}
              {/* <Button
                    type='primary'
                    onClick={() => set_isEdit(true)}
                    style={{ float: 'right', marginTop: 16 }}
                  >
                    Update
                  </Button> */}
              {/* )} */}
            </div>
            {/* )} */}
          </>
        ) : (
          <Table
            columns={columns}
            dataSource={autoChannelSyncs}
            ellipsis={true}
            pagination={{ defaultPageSize: 4, size: 'small' }}
            // scroll={{
            //   y: '50vh',
            // }}
            //   showHeader={false}
          />
        )}
      </Card>
    </>
  );
};

export default withRouter(ChannelSync);
